<template>
    <div class="favorite-roles">
        <header>Favorite Roles</header>

        <div class="navigation navigation-left" @click="navLeft()"><span class="mdi mdi-arrow-left"></span></div>

        <div class="favorite-roles-list">
            <FavoriteRoleItem v-for="favoriteRole in favoriteRoles.slice(0,3)" v-bind="favoriteRole" v-bind:key="favoriteRole.id" />
        </div>

        <div class="navigation navigation-right" @click="navRight()"><span class="mdi mdi-arrow-right"></span></div>
    </div>
</template>

<script>
    import axios from 'axios';
    import VFAPI from '@/modules/module.api.js';
    
    import FavoriteRoleItem from '@/components/FavoriteRoles/FavoriteRoleItem.vue';

    export default {
        name: 'FavoriteRoles',
        data: function() {
            return {
                vfapi: null,
                favoriteRoles: [],
                allFavoriteRoles: [],
            }
        },
        components: {
            FavoriteRoleItem,
        },
        mounted: function() {
            this.$data.vfapi = new VFAPI();

            this.$data.vfapi.getItems('favorite_role', 'role.role_name,role.role_work,pixel_image.data.url').then(data => {
                this.$data.allFavoriteRoles = data;
                this.loadRoles();
            });
        },
        methods: {
            navLeft: function() {
                this.$data.allFavoriteRoles.unshift(this.$data.allFavoriteRoles.pop());
                this.loadRoles();
            },
            navRight: function() {
                this.$data.allFavoriteRoles.push(this.$data.allFavoriteRoles.shift());
                this.loadRoles();
            },
            loadRoles: function() {
                this.$data.favoriteRoles = this.$data.allFavoriteRoles;
            },
        }
    };
</script>

<style scoped lang="less">
    .favorite-roles {
        display: grid;
        grid-template-columns: 50px 1fr 50px;
        grid-gap: 25px;
        padding: 50px 0px;
        padding-top: 25px;
        max-width: 1200px;
        margin: 0 auto;

        & header {
            grid-column: 1 / span 3;
            text-align: center;
            font-weight: bold;
            font-size: 32px;
            margin-bottom: 15px;
        }
        & .navigation {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
            box-shadow: 0px 2px 15px rgba(0,0,0,0.3);
            transition: 0.2s ease-in-out all;
            width: 50px;
            height: 50px;
            align-self: center;
            justify-self: center;
            border-radius: 100px;
            font-size: 22px;

            &:hover {
                background: #fff;
                box-shadow: 0px 2px 25px rgba(0,0,0,0.45);
                cursor: pointer;
            }
        }

        & .favorite-roles-list {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: auto;
            grid-auto-rows: 0px;
            overflow: hidden;
            grid-gap: 10px;
        }
    }

    @media screen and (max-width: 1250px) {
        .favorite-roles {
            width: 95vw;

            & .favorite-roles-list {
                grid-template-columns: 1fr 1fr;
            }
        }
    }

    @media screen and (max-width: 700px) {
        .favorite-roles {
            & .favorite-roles-list {
                grid-template-columns: 1fr;
            }
        }
    }
</style>
